import axiosInstance from "./axiosInstance";

export const addressCountSiteUsed = (params) => {
  return axiosInstance.get(`address/countSiteUsed`, { params: params });
};

export const addressGetList = (params, currentPage, recordPerPage) => {
  return axiosInstance.get(
    `address?page=${currentPage}&limit=${recordPerPage}`,
    { params: params },
  );
};
